import { render, staticRenderFns } from "./RutasView.vue?vue&type=template&id=303a1af2"
import script from "./RutasView.vue?vue&type=script&lang=js"
export * from "./RutasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports